import SplineAreaSegment from '../area-chart/spline-area-segment';

class SplineRadarAreaSegment extends SplineAreaSegment {
    fillToAxes() {}
}

export default SplineRadarAreaSegment;